// removed by extract-text-webpack-plugin
module.exports = {"container":"_3EfH7CQTfQsI20V2F7P6Nh","btnWrap":"_3grp0zBL0FQxAKEUHc8MWO"};


//////////////////
// WEBPACK FOOTER
// ./src/client/Components/PromptModal/PromptModal.css
// module id = 979
// module chunks = 58